// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__IwQww","loader":"Loader_loader__DnRQG","load":"Loader_load__zIxIs"};